export * from './IResponsible';
export * from './IUpdateResponsible';
export { ResponsibleType } from '@shared/enums/ResponsibleType';
